import {
  ClockIcon,
  LockClosedIcon,
  UserGroupIcon,
  SparklesIcon,
  CalendarIcon
} from "@heroicons/react/24/outline"

export const FeatureSection = () => {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold tracking-tight text-gray-900">
            Create memories that last
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Digital time capsules for your most precious moments
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 auto-rows">
          {/* Main Feature */}
          <div className="row-span-2 md:col-span-2 rounded-3xl bg-gradient-to-br from-primary-50 to-primary-100 p-8 flex flex-col justify-between">
            <div>
              <SparklesIcon className="h-8 w-8 text-primary-600" />
              <h3 className="mt-4 text-2xl font-semibold text-gray-900">
                Digital Time Capsules
              </h3>
              <p className="mt-2 text-gray-600">
                Create digital time capsules filled with your thoughts and memories. Set a
                future date and let the anticipation build until the magical moment of
                opening.
              </p>
            </div>
          </div>

          {/* Sharing Feature */}
          <div className="row-span-2 rounded-3xl bg-gradient-to-br from-purple-50 to-purple-100 p-6">
            <UserGroupIcon className="h-6 w-6 text-purple-600" />
            <h3 className="mt-4 text-lg font-semibold text-gray-900">
              Share with Friends
            </h3>
            <p className="mt-2 text-sm text-gray-600">
              Invite others to contribute their memories to shared capsules
            </p>
          </div>

          {/* Privacy Feature */}
          <div className="rounded-3xl bg-gradient-to-br from-red-50 to-red-100 p-6">
            <LockClosedIcon className="h-6 w-6 text-red-600" />
            <h3 className="mt-4 text-lg font-semibold text-gray-900">Private & Secure</h3>
            <p className="mt-2 text-sm text-gray-600">
              Your memories are safely stored and locked until the opening date
            </p>
          </div>

          {/* Countdown Feature */}
          <div className="rounded-3xl bg-gradient-to-br from-amber-50 to-amber-100 p-6">
            <ClockIcon className="h-6 w-6 text-amber-600" />
            <h3 className="mt-4 text-lg font-semibold text-gray-900">Countdown Timer</h3>
            <p className="mt-2 text-sm text-gray-600">
              Watch the excitement build as you count down to the opening day
            </p>
          </div>

          {/* Future Opening Feature */}
          <div className="rounded-3xl bg-gradient-to-br from-emerald-50 to-emerald-100 p-6">
            <CalendarIcon className="h-6 w-6 text-emerald-600" />
            <h3 className="mt-4 text-lg font-semibold text-gray-900">Future Opening</h3>
            <p className="mt-2 text-sm text-gray-600">
              Set any future date to unlock and reveal your preserved memories
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
